import { render, staticRenderFns } from "./kc-my-show.vue?vue&type=template&id=6b825f84&scoped=true"
import script from "./kc-my-show.vue?vue&type=script&lang=js"
export * from "./kc-my-show.vue?vue&type=script&lang=js"
import style0 from "./kc-my-show.vue?vue&type=style&index=0&id=6b825f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b825f84",
  null
  
)

export default component.exports